import { OrderStatusType } from '@/@types/order';

export interface OrderProcessType {
  statuses: OrderStatusType[];
  label: string;
}

export const deliveryProcess: Array<OrderProcessType> = [
  { statuses: [OrderStatusType.Ready], label: '금액 설정' },
  { statuses: [OrderStatusType.WaitingPayment], label: '결제 진행' },
  { statuses: [OrderStatusType.RequestPickup], label: '배차 요청' },
  { statuses: [OrderStatusType.PickupCheck], label: '수거 대기' },
  { statuses: [OrderStatusType.PickupComplete], label: '수거 완료' }
];

export const pickupProcess: Array<OrderProcessType> = [
  { statuses: [OrderStatusType.Ready], label: '금액 설정' },
  { statuses: [OrderStatusType.WaitingPayment], label: '결제 진행' },
  {
    statuses: [
      OrderStatusType.RequestPickup,
      OrderStatusType.PartnershipPickupRequest,
      OrderStatusType.ImmediateOrder
    ],
    label: '픽업 요청'
  },
  { statuses: [OrderStatusType.PartnershipPickupCheck], label: '수령 대기' },
  { statuses: [OrderStatusType.PickupComplete], label: '수령 완료' }
];
